var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layouts)?_c('O3D',[_c('O3D',{attrs:{"animated":true,"layout":'bglayer'}},[_c('RiverField',{attrs:{"mode":'magic'}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }